import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { AnimatedPage } from "../components/AnimatedPage";
import { CTASection } from "../components/CTASection";
import { PageHero } from "../components/PageHero";
import { Section } from "../components/Section";
import { products } from "../data/site";

export default function Products() {
  return (
    <AnimatedPage>
      <PageHero
        eyebrow="Ready-made products"
        title="Software products that help businesses launch faster"
        description="Choose a proven platform, request a demo, then customize workflows, branding, integrations, and deployment around your organization."
      />
      <Section
        eyebrow="Solutions"
        title="Launch-ready platforms for real business operations"
        description="Every package is designed to be practical, scalable, and adaptable to the way your team works."
      >
        <div className="grid gap-5 lg:grid-cols-3">
          {products.map((product) => {
            const Icon = product.icon;
            return (
              <article key={product.name} className="glass-card p-6">
                <div className="flex items-start justify-between gap-5">
                  <div className="rounded-2xl bg-brand-gradient p-3 shadow-glow">
                    <Icon className="h-5 w-5 text-white" />
                  </div>
                  <span className="rounded-full border border-white/10 px-3 py-1 text-xs text-white/50">
                    Product
                  </span>
                </div>
                <h2 className="mt-6 font-display text-xl font-semibold text-white">
                  {product.name}
                </h2>
                <p className="mt-3 text-sm leading-6 text-white/60">
                  {product.description}
                </p>
                <ul className="mt-6 grid gap-3">
                  {product.features.map((feature) => (
                    <li
                      key={feature}
                      className="flex items-center gap-3 text-sm text-white/70"
                    >
                      <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-300/10 text-emerald-200">
                        <Check className="h-3.5 w-3.5" />
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="btn btn-secondary mt-7 w-full justify-center">
                  Request Demo
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </article>
            );
          })}
        </div>
      </Section>
      <CTASection />
    </AnimatedPage>
  );
}
